export default __webpack_public_path__ + "static/media/Time.b63d1f5a.svg";